import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import UserAgentUtils from '../../../utils/userAgent';
import { StyledShareButton, ShareButtonLabel } from './styles';
import { ShareOrigin, share } from '../../../containers/Share/actions';
import Tooltip from '../../Tooltip';
import { Translate } from 'react-redux-i18n';

interface ShareButtonProps {
	shareOrigin: ShareOrigin;
	galleryConfig: Api.Config;
	isInBottomBar?: boolean;
	dispatch: Dispatch<StoreState>;
	isNativeShare: boolean;
	sharedItems: Api.DriveItem[];
}

const ShareButton = (props: ShareButtonProps) => {

	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		const { sharedItems, dispatch } = props;

		dispatch(share(sharedItems));
	};

	const { isInBottomBar } = props;
	const tooltipId = Utils.generateId();
	const isTooltipDisplayed = UserAgentUtils.isDesktop() && !isInBottomBar;

	return (
		<StyledShareButton isInBottomBar={isInBottomBar} onClick={handleClick} data-tip={true} data-for={tooltipId}>
			{Utils.getSvgIcon('iconset_uprez_share')}
			{isInBottomBar &&
				<ShareButtonLabel>
					<Translate value={'messages.share_my_selection'}/>
				</ShareButtonLabel>
			}
			{isTooltipDisplayed &&
				<Tooltip id={tooltipId} text={'messages.share'} />
			}
		</StyledShareButton>
	);
};

export { ShareButtonProps };
export default ShareButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/ShareButton/index.tsx